
import { Component, Vue } from "vue-property-decorator";
import { CANDIDATE_ASSESSMENT_SERVICE, START_SERVICE_EVENT } from "@/constants/services";

const EMPLOYER_CCA_REQUEST_ALIAS = "employer_cca";

const MESSAGES = {
  buttons: {
    start: "Start",
  },
};

const SERVICE = {
  id: 1,
  alias: EMPLOYER_CCA_REQUEST_ALIAS,
  buttonLabel: "Get a complimentary\n candidate eligibility check",
  title: "Check whether your candidate \nis eligible for a Worker visa",
  paragraph_1:
    "Before you assign a Certificate of Sponsorship (CoS) and start a new visa process for your candidate, it is a good idea to check whether or not they are eligible to be sponsored under the Skilled Worker route and If there is the risk of visa refusal by the Home Office.",
  paragraph_2:
    "Click 'Start' and select a job position template. Then, you will be able to assess how likely your candidate is to receive a Worker visa.",
  benefitsTitle: "This eligibility check will help you and your candidate assess:",
  benefits: [
    "Whether the candidate is eligible for a Skilled Worker visa",
    "The fees that will need to be paid to the Home Office",
    "The estimated timeline to go through the sponsorship and visa processes",
  ],
  note_1:
    "Please note that the eligibility check does not guarantee the actual candidate’s eligibility, since any actual visa decision is going to be made by the Home Office officials only. ",
};

const INITIAL_SERVICE_REQUEST_OPTION = 1;

const EMPLOYER_ROLES_ROUTE = "EmployerRoleTemplates";

@Component
export default class WidgetCandidateAssessment extends Vue {
  service = SERVICE;

  messages = MESSAGES;

  selectedOption = INITIAL_SERVICE_REQUEST_OPTION;

  popup = false;

  openPopup() {
    this.$emit("start");

    this.popup = true;
  }

  closePopup() {
    this.popup = false;
  }

  get startButtonName() {
    return this.messages.buttons.start;
  }

  // NOTE: If services number will be more then 1, use implementation like in "WidgetSkilledWorkerVisa" component;
  // NOTE: DEV-1167. May be need to deprecate;
  // getServiceAlias() {
  //   const item = this.service;

  //   if (!item) return null;

  //   return item.alias;
  // }

  // async submitRequest() {
  //   const alias = this.getServiceAlias();

  //   if (!alias) return;

  //   try {
  //     await this.axios.get(API_ROUTES.SERVICE_REQUEST(alias));

  //     this.$emit("on-submit");
  //   } finally {
  //     this.closePopup();
  //   }
  // }

  async startAssessment() {
    try {
      await this.$router.push({
        name: EMPLOYER_ROLES_ROUTE,
        params: {
          event: START_SERVICE_EVENT,
          service: CANDIDATE_ASSESSMENT_SERVICE,
        },
      });
    } finally {
      this.closePopup();
    }
  }
}
